import * as React from "react";
import { useState, useEffect } from "react";
import mailIcon from "../../../../../assets/images/icons/mail.svg";
import deleteIcon from "../../../../../assets/images/icons/trash-2.svg";
import resetIcon from "../../../../../assets/images/icons/rotate-ccw.svg";
import editIcon from "../../../../../assets/images/icons/edit.svg";
import { AddIcon, BellIconSmall } from "src/app/polar-SAAS-Components/components/Icons"
import CreateUser from "src/app/popup/CreateUser";
import EditUser from "src/app/popup/EditUser";
import { getCorporates, getKits, getProject } from "src/services/corporateService";
import {Corporate, MagmaResponse, Project} from '../../../../../app/models';
import { createUserForCorporate, updateUserForCorporate, createProjectUser, updateUser, deleteCorporateUser,
       deleteUser, resendRegistrationMail,fetchMetaData, deleteUserForKit, createUserForKit, updateUserForKit, updateAlertSettingsForKitUser,
        getAlertSettingsForKitUser,getKitsOfProjectForUser ,getExistingProjectUsers,addExistingUser } from "src/app/polar-SAAS-Components/api-helper";
import { UserData } from "src/app/polar-SAAS-Components/models-new";
import { getUsersOfCorporate, getUsersOfProject, getUsersOfKit } from "src/services/corporateService";
import { clearQueryParam  } from "src/app/polar-SAAS-Components/utilsNew";
import { USER_ROLES } from "src/app/enums";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import  authService  from "src/app/polar-SAAS-Components/auth-service";
import  ProjectService  from "src/app/project/ProjectService";
import {ArrowBackIcon,AssignUserIcon,AddUserIcon} from "src/app/polar-SAAS-Components/components/Icons";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";
import useStyleClasses from "src/app/polar-SAAS-Components/style";
import { environment } from "src/environments/environment";

type Status = "Active" | "Inactive";
type ActiveTab = "corporate" | "project" | "kits";

type BaseUser = {
  id: string;
  name: string;
  username: string;
  email: string;
  mobile: string;
  whatsApp: string;
  role: string;
  status: Status;
};

type KitUser = BaseUser & {
  sms: boolean;
  emailAlert: boolean;
  whatsappAlert: boolean;
};

type AlertSettings = {
  sms: boolean;
  emailAlert: boolean;
  whatsappAlert: boolean;
  enabled: boolean;
  isWAnSMSPermitted:boolean;
};
type AlertSettingsProject = {
  sms: boolean;
  emailAlert: boolean;
  whatsappAlert: boolean;
  enabled: boolean;
  kitId:string;
};

// Add interface for the AssignUsersPopup component
interface AssignUsersPopupProps {
  onClose: () => void;
  onSave: (selectedProject: string, selectedUsers: string[]) => void;
  projects: Array<{ id: string; name: string,corporateId:string }>;
}

// Add interface for the Alert Settings popup
interface AlertSettingsPopupProps {
  onClose: () => void;
  onSave: (settings: AlertSettings) => void;
  initialSettings: AlertSettings;
  userName: string;
}

// Add component for the Assign Users popup
const AssignUsersPopup: React.FC<AssignUsersPopupProps> = ({
  onClose,
  onSave,
  projects
}) => {
  const [selectedProject, setSelectedProject] = useState<string>("");
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [usersOtherProjects, setUsersOtherProjects] = useState<any[]>([]);

  // Fetch existing users for the selected project whenever selection changes
  useEffect(() => {
    const fetchUsersForProject = async (projectId: string) => {
      if (!projectId) {
        setUsersOtherProjects([]);
        return;
      }

      try {
        const projectObj = projects.find((p: any) => p.id === projectId);
        const corporateId = projectObj ? (projectObj.corporateId || projectObj.corporateId) : undefined;
        const response = await getExistingProjectUsers( corporateId,projectId);
        const data = (response.data.content) || [];
        setUsersOtherProjects(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching existing project users:", err);
        setUsersOtherProjects([]);
      }
    };

    fetchUsersForProject(selectedProject);
  }, [selectedProject, projects]);
  const handleUserSelect = (userId: string) => {
    if (selectedUsers.includes(userId)) {
      setSelectedUsers(selectedUsers.filter(id => id !== userId));
    } else {
      setSelectedUsers([...selectedUsers, userId]);
    }
  };

  const handleSave = () => {
    onSave(selectedProject, selectedUsers);
    onClose();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={modalHeaderStyle}>
          ASSIGN PROJECT USERS
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">
            ×
          </button>
        </div>
        
        <div style={modalContentStyle}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Project</label>
            <select
              value={selectedProject}
              onChange={(e) => {
                setSelectedProject(e.target.value);
                setSelectedUsers([]); // reset selected users when project changes
              }}
              style={selectStyle}
            >
              <option value="">Select project</option>
              {projects.map(project => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          
          <div style={formGroupStyle}>
            <label style={labelStyle}>Users</label>
            <div style={usersListStyle}>
              {(usersOtherProjects.length > 0 ? usersOtherProjects.map((user: any) => (
                <div key={user.id} style={userItemStyle}>
                  <input
                    type="checkbox"
                    id={`user-${user.id}`}
                    checked={selectedUsers.includes(user.id)}
                    onChange={() => handleUserSelect(user.id)}
                    style={checkboxStyle}
                  />
                  <label htmlFor={`user-${user.id}`} style={userLabelStyle}>
                    {user.name || user.lastName || user.username}
                  </label>
                </div>
              )): <div>No users available</div>)}
            </div>
          </div>
        </div>
        
        <div style={modalFooterStyle}>
          <button onClick={onClose} style={btnGhost}>
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            style={btnPrimary}
            disabled={!selectedProject || selectedUsers.length === 0}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

// Add component for the Alert Settings popup
const AlertSettingsPopup: React.FC<AlertSettingsPopupProps> = ({
  onClose,
  onSave,
  initialSettings,
  userName
}) => {
  const [sms, setSms] = useState(initialSettings.sms);
  const [emailAlert, setEmailAlert] = useState(initialSettings.emailAlert);
  const [whatsappAlert, setWhatsappAlert] = useState(initialSettings.whatsappAlert);
  const [enabled, setEnabled] = useState(initialSettings.enabled);

  useEffect(() => {
    setSms(initialSettings.sms);
    setEmailAlert(initialSettings.emailAlert);
    setWhatsappAlert(initialSettings.whatsappAlert);
    setEnabled(initialSettings.enabled);
  }, [initialSettings]);

  useEffect(() => {
    if (!enabled) {
      setSms(false);
      setEmailAlert(false);
      setWhatsappAlert(false);
    }
  }, [enabled]);

  const handleSave = () => {
    const payload: any = enabled
      ? { sms, emailAlert, whatsappAlert, enabled: true }
      : { sms: false, emailAlert: false, whatsappAlert: false, enabled: false };

    onSave(payload);
    onClose();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={modalHeaderStyle}>
          ALERT SETTINGS - {userName}
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">
            ×
          </button>
        </div>

        <div style={modalContentStyle}>
          {/* Master row (single name + toggle) */}
          <div style={toggleItemStyle}>
            <span style={toggleLabelStyle}>Alert</span>
            <Toggle checked={enabled} onChange={setEnabled} />
          </div>

          {/* Channel toggles appear only when master is ON */}
          {enabled && (
            <div style={subGroupStyle}>
              {(authService.isAzureUser() || !initialSettings.isWAnSMSPermitted)&& (  <span style={toggleInfo}> SMS and WhatsApp alerts are not available </span>)}
              <div style={toggleItemStyle}>
                <span style={toggleLabelStyle}>SMS Alert</span>
                <Toggle checked={sms} disabled={authService.isAzureUser() || !initialSettings.isWAnSMSPermitted } onChange={setSms} />
              </div>

              <div style={toggleItemStyle}>
                <span style={toggleLabelStyle}>Email Alert</span>
                <Toggle checked={emailAlert} onChange={setEmailAlert} />
              </div>

              <div style={toggleItemStyle}>
                <span style={toggleLabelStyle}>WhatsApp Alert</span>
                <Toggle checked={whatsappAlert} disabled={authService.isAzureUser() ||  !initialSettings.isWAnSMSPermitted}onChange={setWhatsappAlert} />
              </div>
            </div>
          )}
        </div>

        <div style={modalFooterStyle}>
          <button onClick={onClose} style={btnGhost}>
            Cancel
          </button>
          <button onClick={handleSave} style={btnPrimary}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};
const AlertSettingsProjectPopup: React.FC<any> = ({
  onClose,
  onSave,
  alertSettingProject,
  setAlertSettingsProject,
  user
}) => {




const handleChannelToggle = (kitId, channel) => {
  setAlertSettingsProject(prev =>
    prev.map(kit =>
      kit.kitId === kitId
        ? { ...kit, [channel]: !kit[channel] }
        : kit
    )
  );
};
const handleEnable = (kitId) => {

  setAlertSettingsProject(prev =>
    prev.map(kit =>
      kit.kitId === kitId
        ? { ...kit, enable: !kit.enable }
        : kit
    )
  );
};

  const handleSave = async() => {
    await onSave()
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={modalHeaderStyle}>
          ALERT SETTINGS - {user.userName}
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">
            ×
          </button>
        </div>

        <div style={modalContentStyle}>
          {alertSettingProject.length>0?alertSettingProject.map((kitAlert) => (
            <div key={kitAlert.kitId} style={kitSectionStyle}>
          {/* Master row (single name + toggle) */}
          <div style={toggleItemStyle}>
            <span style={toggleLabelStyle}>Kit - {kitAlert.kitId}</span>
            <Toggle checked={kitAlert.enable} onChange= {()=>handleEnable(kitAlert.kitId)} />
          </div>

          {/* Channel toggles appear only when master is ON */}
          {kitAlert.enable && (
            <div style={subgrpRowStyle}>
              {(authService.isAzureUser() || !kitAlert.isWAnSMSPermitted)&& (<span style={toggleInfo}> SMS and WhatsApp alerts are not available  </span>)}
              <div style={toggleItemGrid}>
                <span style={toggleLabelStyle}>SMS Alert</span>
                <Toggle checked={kitAlert.SMS} disabled={authService.isAzureUser() || !kitAlert.isWAnSMSPermitted } onChange={() => handleChannelToggle(kitAlert.kitId, 'SMS')} />
              </div>

              <div style={toggleItemGrid}>
                <span style={toggleLabelStyle}>Email Alert</span>
                <Toggle checked={kitAlert.EMAIL} onChange={() => handleChannelToggle(kitAlert.kitId, 'EMAIL')} />
              </div>

              <div style={toggleItemGrid}>
                <span style={toggleLabelStyle}>WhatsApp Alert</span>
                <Toggle checked={kitAlert.WHATSAPP}  disabled={authService.isAzureUser() || !kitAlert.isWAnSMSPermitted } onChange={() => handleChannelToggle(kitAlert.kitId, 'WHATSAPP')} />
              </div>
            </div>
          )}
          </div>)): <span style={toggleLabelStyle}>No Kit Alert settings available.</span>}
        </div>

        <div style={modalFooterStyle}>
          <button onClick={onClose} style={btnGhost}>
            Cancel
          </button>
          <button onClick={handleSave} style={btnPrimary}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

// Add Toggle component
const Toggle = ({
  checked,
  onChange,
  disabled,
  onClick
}: {
  checked: boolean;
  onChange?: (val: boolean) => void;
  disabled?: boolean;
  onClick?: () => void;
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick || (() => !disabled && onChange && onChange(!checked))}
    aria-pressed={checked}
    style={{
      width: 36,
      height: 20,
      borderRadius: 999,
      border: "1px solid #e5e7eb",
      background: checked ? "#dbeafe" : "#f3f4f6",
      position: "relative",
      cursor: disabled ? "not-allowed" : "pointer",
      transition: "background-color 0.2s",
    }}
  >
    <span
      style={{
        position: "absolute",
        top: "50%",
        left: checked ? 18 : 2,
        width: 16,
        height: 16,
        borderRadius: "50%",
        background: checked ? "#2A7CED" : "#9ca3af",
        transform: "translateY(-50%)",
        transition: "left 120ms, transform 120ms",
      }}
    />
  </button>
);

const UserSetting: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("kits");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [showCreateUserPopup, setShowCreateUserPopup] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showResendConfirmation, setShowResendConfirmation] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [userToDelete, setUserToDelete] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState({
    entityId: "",
    entityName: "",
    email: "",
    name: "",
    mobile: "",
    whatsApp: "",
    status: "active" as "active" | "suspend",
  });
  const [showAssignUsersPopup, setShowAssignUsersPopup] = useState(false);
  const [corporates, setCorporates] = useState<Corporate[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [selectedCorporateId, setSelectedCorporateId] = useState<string>("");
  const [corporateUsers, setCorporateUsers] = useState<BaseUser[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState<string>("");
  const [projectUsers, setProjectUsers] = useState<BaseUser[]>([]);
  const [kits, setKits] = useState<Project[]>([]);
  const [selectedKitId, setSelectedKitId] = useState<string>("");
  const [kitUsers, setKitUsers] = useState<KitUser[]>([]);
  const [editingUserId, setEditingUserId] = useState<string | null>(null);
  const [showAlertSettings, setShowAlertSettings] = useState(false);
  const [showAlertSettingsProject, setShowAlertSettingsProject] = useState(false);
  const [currentAlertSettings, setCurrentAlertSettings] = useState<AlertSettings>({
    sms: false,
    emailAlert: false,
    whatsappAlert: false,
    enabled: false,
    isWAnSMSPermitted:true
  });
    const [currentAlertSettingsProject, setCurrentAlertSettingsProject] = useState<any[]>([{
    kitId:"",
    SMS: false,
    EMAIL: false,
    WHATSAPP: false,
    enable: false,
    isWAnSMSPermitted:true
  }]);
  const [currentAlertUser, setCurrentAlertUser] = useState<KitUser | null>(null);
  const [openToaster,setopenToaster]=useState(false);
  const [msg,setMsg]=useState("");
  const [success,setSuccess]=useState(true);
  const [loading, setLoading] = useState(false);
  const [userLog,setUserLog]=useState([]);
  const [showuserLog,setshowUserLog]=useState(false);

  const [pageLoadedMax, setPageLoadedMax] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error,setError]=React.useState<string|null>(null);
  const [isAllRetrieved, setIsAllRetrieved] = React.useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const corporateIdFromParams = queryParams.get("corporateId");
  const projectIdFromParams = queryParams.get("projectId");
  const projectService = new ProjectService();
  const [meta, setMeta] = React.useState(null);

  useEffect(() => {
    fetchMetaData().then(res => {
      if(res.data && res.data.content && res.data.content.configuration){
        setMeta(res.data.content.configuration);
      }
    });
  }, []);

  const isMobile = useIsMobile(768);
    const styleClasses = useStyleClasses(isMobile);

  useEffect(() => {
    const normalizeId = (v?: string | null) => {
      if (!v) return null;
      const s = v.trim().toLowerCase();
      if (s === "" || s === "null" || s === "undefined") return null;
      return v;
    };

    const corpParam = normalizeId(corporateIdFromParams);
    const projParam = normalizeId(projectIdFromParams);

    if (projParam) {
      setActiveTab("project");
      handleProjectChange(projParam);
    } else if (corpParam) {
      setActiveTab("corporate");
      handleCorporateChange(corpParam);
    } else {
      if ((!selectedCorporateId || selectedCorporateId.length === 0) && corporates && corporates.length > 0) {
        handleCorporateChange(corporates[0].id);
      }
      if ((!selectedProjectId || selectedProjectId.length === 0) && projects && projects.length > 0) {
        handleProjectChange(projects[0].id);
      }
    }
  }, [corporates, projects, corporateIdFromParams, projectIdFromParams]);


  useEffect(() => {
    const fetchCorporates = async () => {
      try {
        const res = await getCorporates();
        const data = res && res.content ? res.content : [];
        setCorporates(data);
      } catch (error) {
        console.error("Failed to fetch corporates", error);
      }
    };

    const fetchProjects = async () => {
      try {
        const res = await getProject();
        const data = res && res.data.content ? res.data.content : [];
        setProjects(data);
      } catch (error) {
        console.error("Failed to fetch projects", error);
      }
    };
        const fetchKits = async () => {
      try {
        const res = await getKits();
        const data = res && res.data.content ? res.data.content : [];
        setKits(data);

        // Default-select first kit
        if (data.length > 0) {
          const firstKitId = data[0].id;
          setSelectedKitId(firstKitId);
          handleKitChange(firstKitId);
        }
      } catch (error) {
        console.error("Failed to fetch kits", error);
      }
    };

    if (activeTab == "corporate") {
      fetchCorporates();
    }
    else if (activeTab == "project") {
      fetchProjects();
    }
    else if (activeTab == "kits") {
      fetchKits();
    }
  }, [activeTab]);

//user log 
const PAGE_SIZE =  10;
const PAGE_SIZE_MOBILE=5;
  const pageSize = isMobile ? PAGE_SIZE_MOBILE : PAGE_SIZE;

  const fetchPage = async (offset: number,userId:string,page:number): Promise<boolean> => {
    if (isLoading || isAllRetrieved) return false;
    setIsLoading(true);
    setError(null);
    try {
      const res =   await projectService.getUserActionHistory(userId, pageSize,page);

      const data = (res.data as MagmaResponse<any[]>).content || [];

      if (data.length < pageSize) setIsAllRetrieved(true);
      if (data.length > 0) {
        setUserLog((prev) => {
          const next = prev.slice();
          const startIndex = offset * pageSize;
          for (let i = 0; i < data.length; i++) {
            next[startIndex + i] = data[i];
          }
          return next;
        });
        setPageLoadedMax((prev) => (offset > prev ? offset : prev));
        return true;
      }
      return false;
    } catch {
      setError("Failed to load notifications. Please try again.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const totalPagesLoaded = Math.ceil(userLog.length / PAGE_SIZE);
  const effectiveTotalPages = isAllRetrieved
    ? totalPagesLoaded
    : Math.max(totalPagesLoaded, pageLoadedMax + 1);



  const goToPage = async (page: number) => {
    if (page < 1) return;
    const neededOffset = page - 1;
    if (neededOffset > pageLoadedMax && !isAllRetrieved) {
      const ok = await fetchPage(neededOffset,editingUserId||"",page);
      if (!ok) return;
    }
    setCurrentPage(page);
  };

  const nextPage = () => {
    const next = currentPage + 1;
    if (next <= effectiveTotalPages || !isAllRetrieved) {
      void goToPage(next);
    }
  };

  const previousPage = () => {
    const prev = currentPage - 1;
    if (prev >= 1) {
      void goToPage(prev);
    }
  };

  const visiblePages = () => {
    const maxVisiblePages = isMobile ? 3 : 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(effectiveTotalPages, startPage + maxVisiblePages - 1);
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    const pages: number[] = [];
    for (let p = startPage; p <= endPage; p++) pages.push(p);
    return { pages, startPage, endPage };
  };


  const startIndex = (currentPage - 1) * pageSize;
  const displayed = userLog.slice(startIndex, startIndex + pageSize);

//



    const showToasterMessage = (message: string, isSuccess = true, duration = 4000) => {
    setMsg(message);
    setSuccess(isSuccess);
    setopenToaster(true);
    setTimeout(() => setopenToaster(false), duration);
  };
const canCreateUser = () => {
  if(activeTab=="kits"&&(authService.isAzureUser()||authService.isSuperAdmin())){
    return true;
  }
  if(authService.isMobileSAASAdmin()){ //currently single user option is available for mobile SAAS users
    return false;
  }

  if (activeTab === "project") {
    return authService.hasProjectManagementAccess();
  }

  if (activeTab === "corporate") {
    return authService.isSuperAdmin()||authService.isCorporateAdmin();
  }

  return false;
};

  const getCorporateName = (corporateId: string) => {
    const corporate = corporates.find(c => c.id === corporateId);
    return corporate ? corporate.name : "Unknown";
  };

  const getProjectName = (projectId: string) => {
    const project = projects.find(c => c.id === projectId);
    return project ? project.name : "Unknown";
  };

  const getKitName = (kitId: string) => {
    const kit = kits.find(k => k.id === kitId);
    return kit ? kit.name : "Unknown Kit";
  };

  const handleKitChange = async (kitId: string) => {
    setSelectedKitId(kitId);
    if (!kitId) {
      setKitUsers([]);
      return;
    }

    try {
      setLoadingUsers(true);
      const response = await getUsersOfKit(kitId);

      if (response.statusCode === "S1000" && Array.isArray(response.content)) {
        const mappedUsers: KitUser[] = response.content.map((u: any) => ({
          id: u.id || "", 
          name: u.lastName || "Unknown",
          username: u.username || "",
          email: u.email || "",
          mobile: u.mobile || "",
          whatsApp: u.whatsApp || "",
          role: u.userRoleId ? getLevelName(u.userRoleId) : "N/A",
          status: u.status === "ACTIVE" ? "Active" : "Inactive",
          sms: u.sms || false,
          emailAlert: u.emailAlert || false,
          whatsappAlert: u.whatsappAlert || false,
        }));
        setKitUsers(mappedUsers);
      } else {
        setKitUsers([]);
      }
    } catch (error) {
      console.error("Error fetching kit users:", error);
      setKitUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };
const hasMenuAccess = (tab) => {
  let hasKitUser = false;
  if (meta) {hasKitUser= meta.hasKitUser;}

  const raw = localStorage.getItem('ROLE');
  const role = Number.isFinite(Number(raw))
    ? Number(raw)
    : (typeof authService.getRole === 'function'
        ? Number(authService.getRole())
        : 0);

  if (isNaN(role)) return false;

  if (tab.id === "corporate") return role <= 101;
  if (tab.id === "project") return role <= 1000 || hasKitUser;
  if (tab.id === "kits") return role < 10000 || hasKitUser;

  return false;
};

  const handleCorporateChange = async (corporateId: string) => {
    setSelectedCorporateId(corporateId);
    if (!corporateId) {
      setCorporateUsers([]);
      return;
    }

    try {
      setLoadingUsers(true);
      const response = await getUsersOfCorporate(corporateId);

      if (response.statusCode === "S1000" && Array.isArray(response.content)) {
        const mappedUsers: BaseUser[] = response.content.map((u: any) => ({
          id: u.id || "", 
          name: u.lastName || "Unknown",
          username: u.username || "",
          email: u.email || "",
          mobile: u.mobile || "",
          whatsApp: u.whatsApp || "",
          role: u.userRoleId ? getLevelName(u.userRoleId) : "N/A",
          status: u.status === "ACTIVE" ? "Active" : "Inactive",
        }));
        setCorporateUsers(mappedUsers);
      } else {
        setCorporateUsers([]);
      }
    } catch (error) {
      console.error("Error fetching corporate users:", error);
      setCorporateUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const getLevelName=(level) =>{
    return USER_ROLES.find((element) => {
      return element.userRoleId === level;
    }).roleName;
  }
  const handleProjectChange = async (projectId: string) => {
    setSelectedProjectId(projectId);
    if (!projectId) {
      setProjectUsers([]);
      return;
    }

    try {
      setLoadingUsers(true);
      const response = await getUsersOfProject(projectId);

      if (response.statusCode === "S1000" && Array.isArray(response.content)) {
        const mappedUsers: BaseUser[] = response.content.map((u: any) => ({
          id: u.id || "", 
          name: u.lastName || "Unknown",
          username: u.username || "",
          email: u.email || "",
          mobile: u.mobile || "",
          whatsApp: u.whatsApp || "",
          role: u.userRoleId ? getLevelName(u.userRoleId) : "N/A",
          status: u.status === "ACTIVE" ? "Active" : "Inactive",
        }));
        setProjectUsers(mappedUsers);
      } else {
        setProjectUsers([]);
      }
    } catch (error) {
      console.error("Error fetching project users:", error);
      setProjectUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleDeleteUser = async (user: any) => {
    if (!user.id) return;

    try {
      let response;

      if (activeTab === "corporate" && selectedCorporateId) {
        response = await deleteCorporateUser(selectedCorporateId, user.id);
        await handleCorporateChange(selectedCorporateId);

      } else if (activeTab === "project" && selectedProjectId) {
        response = await deleteUser(selectedProjectId, user.id);
        await handleProjectChange(selectedProjectId);

      } else if (activeTab === "kits" && selectedKitId) {
        response = await deleteUserForKit(selectedKitId, user.id);
        await handleKitChange(selectedKitId);
      }


      setShowDeleteConfirmation(false);
      setUserToDelete(null);
      showToasterMessage("User deleted successfully!", true);
    } catch (error) {
      console.error("Error deleting user:", error);
      showToasterMessage("Failed to delete user. Please try again.", false);
    }
  };

  const handleResendMail = async (user: any) => {
    const data = await fetchMetaData();
      const baseUrl = environment.host.substring(0, environment.host.lastIndexOf("/"));
    const hostUrl = (data && data.configuration && data.configuration.configHost) || `${baseUrl}/sign-up`;
    try {
      const payload = {
        host: hostUrl,
        email: user.email,
      };

      await resendRegistrationMail(payload);

      setShowResendConfirmation(false);
      setUserToDelete(null);
      showToasterMessage("Registration mail resent successfully!", true);
    } catch (error) {
      console.error("Error resending registration mail:", error);
      let errMsg = "Failed to resend mail. Please try again.";
      const errAny: any = error;
      if (errAny && errAny.response && errAny.response.data && errAny.response.data.message) {
        errMsg = errAny.response.data.message;
      } else if (errAny && errAny.message) {
        errMsg = errAny.message;
      }
      showToasterMessage(errMsg, false);
    }
  };



  const tabs: Array<{ id: ActiveTab; label: string }> = [
    { id: "corporate", label: "Corporate"+(isMobile ? "  " : " User") },
    { id: "project", label: "Project"+(isMobile ? "  " : " User")},
    { id: "kits", label: "Kit"+(isMobile ? "  " : " User")},
  ];

  const StatusBadge = ({ status }: { status: Status }) => (
    <span
      style={{
        padding: "4px 12px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 500,
        backgroundColor: status === "Active" ? "#dcfce7" : "#fee2e2",
        color: status === "Active" ? "#02C170" : "#FF4343",
        border: status === "Active" ? "1px solid #02C170" : "1px solid #FF4343",
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );

  const ImageIcon = ({ src, alt, size = 16 }: { src: string; alt: string; size?: number }) => (
    <img src={src} alt={alt} style={{ width: size, height: size, objectFit: "contain" }} />
  );

  const ActionButton = ({
    icon,
    iconSrc,
    altText,
    onClick,
  }: {
    icon?: React.ReactNode;
    iconSrc?: string;
    altText: string;
    onClick: () => void;
  }) => (
    <button
      onClick={onClick}
      style={{
        padding: 6,
        border: "none",
        background: "none",
        cursor: "pointer",
        borderRadius: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = "#f3f4f6")}
      onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = "transparent")}
      aria-label={altText}
      title={altText}
    >
      {icon ? icon : iconSrc ? <ImageIcon src={iconSrc} alt={altText} size={16} /> : null}
    </button>
  );

  const loadAlertSettingsProject = async (userId) => {
  try {
    setLoadingUsers(true);
    const alertSettingsProject=[];
    const response = await getKitsOfProjectForUser(
      userId,
      selectedProjectId
    );
    let KitAlertsForProject =response.data.content;

    await Promise.all(
      KitAlertsForProject.map(async(kit) =>{
        const response=await getAlertSettingsForKitUser( kit.id,userId);
        let kitAlert=response.data.content;
        alertSettingsProject.push({
          kitId:kit.id,
          SMS:kitAlert.modes.SMS,
          WHATSAPP:kitAlert.modes.WHATSAPP,
          EMAIL:kitAlert.modes.EMAIL,
          enable:kitAlert.enable,
          isWAnSMSPermitted: authService.isMobileSAASAdmin()? kit.isPremium : true

        })
      
      }
      )
    );
    setCurrentAlertSettingsProject(alertSettingsProject);
    setShowAlertSettingsProject(true);
  } catch (err) {
    setMsg("Error Fetching users alert setting for project");
    setSuccess(false)
    setopenToaster(true);
    setTimeout(function() {
        setopenToaster(false);
      }, 4000);
    
    return;
  } finally {
    setLoadingUsers(false);
  }
};
  const handleAlertSettingsProjectClick = async (user: KitUser)=>{
   if(!selectedProjectId){
    return;
   }
   setCurrentAlertUser(user);
   loadAlertSettingsProject(user.id);  //alert setting for each kit of the project for the user
  }

  // Add handler for opening the alert settings popup
  const handleAlertSettingsClick = async (user: KitUser, _alertType: 'sms' | 'emailAlert' | 'whatsappAlert') => {
    if (!selectedKitId) return;
    const kitSelected=kits.find(kit=>kit.id===selectedKitId);

    const fallbackEnabled = Boolean(user.sms || user.emailAlert || user.whatsappAlert);
    setCurrentAlertUser(user);
    setCurrentAlertSettings({
      sms: !!user.sms,
      emailAlert: !!user.emailAlert,
      whatsappAlert: !!user.whatsappAlert,
      enabled: fallbackEnabled,
      isWAnSMSPermitted: authService.isMobileSAASAdmin()? kitSelected.isPremium : true
    });

    try {
      const response = await getAlertSettingsForKitUser(selectedKitId, user.id);
      const content = (response && (response as any).data && (response as any).data.content) || (response as any).content;

      if (content && content.modes) {
        setCurrentAlertSettings({
          sms: !!content.modes.SMS,
          emailAlert: !!content.modes.EMAIL,
          whatsappAlert: !!content.modes.WHATSAPP,
          enabled: content.enable !== undefined ? !!content.enable : !!(content.modes.SMS || content.modes.EMAIL || content.modes.WHATSAPP),
          isWAnSMSPermitted:authService.isMobileSAASAdmin() ? kitSelected.isPremium : true
        });
        setShowAlertSettings(true);
      }
    } catch (error) {
      console.error("Error fetching alert settings:", error);
      showErrorMessage(error,"Error getting alert Setting")
    }
  };

  // Add handler for saving alert settings
  const handleSaveAlertSettings = async (settings: AlertSettings) => {
    if (!currentAlertUser || !selectedKitId) return;

    try {
      const payload = {
        enable: settings.enabled,
        modes: {
          SMS: settings.sms,
          EMAIL: settings.emailAlert,
          WHATSAPP: settings.whatsappAlert,
        },
      };

      const updateResponse = await updateAlertSettingsForKitUser(selectedKitId, currentAlertUser.id, payload);
      const updateStatus = (updateResponse && (updateResponse as any).status) || (updateResponse && (updateResponse as any).data && (updateResponse as any).data.statusCode);
      const updateSucceeded = updateStatus === 200 || updateStatus === 201 || updateStatus === "S1000";

      let latestSettings: AlertSettings = settings;

      if (updateSucceeded) {
        try {
          const kitCurrentlySelected=kits.find(kit=>kit.id===selectedKitId);
          const latestResponse = await getAlertSettingsForKitUser(selectedKitId, currentAlertUser.id);
          const content = (latestResponse && (latestResponse as any).data && (latestResponse as any).data.content) || (latestResponse as any).content;

          if (content && content.modes) {
            latestSettings = {
              sms: !!content.modes.SMS,
              emailAlert: !!content.modes.EMAIL,
              whatsappAlert: !!content.modes.WHATSAPP,
              enabled: content.enable !== undefined ? !!content.enable : !!(content.modes.SMS || content.modes.EMAIL || content.modes.WHATSAPP),
              isWAnSMSPermitted:authService.isMobileSAASAdmin() ? kitCurrentlySelected.isPremium : true
            };
          }
        } catch (error) {
          console.error("Error fetching updated alert settings:", error);
        }
      } else {
        throw new Error("Updating alert settings did not return success status");
      }

      setKitUsers(prev =>
        prev.map(u =>
          u.id === currentAlertUser.id
            ? {
                ...u,
                sms: latestSettings.sms,
                emailAlert: latestSettings.emailAlert,
                whatsappAlert: latestSettings.whatsappAlert,
              }
            : u
        )
      );
      setShowAlertSettings(false);
      setCurrentAlertUser(null);
      showToasterMessage("Alert settings updated successfully!", true);
    } catch (error) {
      console.error("Error updating alert settings:", error);
      let errMsg = "Please try again.";
      const errAny: any = error;
      if (errAny && errAny.response && errAny.response.data && errAny.response.data.message) {
        errMsg = errAny.response.data.message;
      } else if (errAny && errAny.message) {
        errMsg = errAny.message;
      }
      showToasterMessage(`Failed to update alert settings: ${errMsg}`, false);
    }
  };

  const handleProjectKitsAlertSettings=async()=>{
    try{
    setLoadingUsers(true);
    currentAlertSettingsProject.forEach(async(kit) => {
      const payload={
        enable:kit.enable,
        modes:{
        EMAIL:kit.EMAIL,
        WHATSAPP:kit.WHATSAPP,
        SMS:kit.SMS        }
      }
      const response=await updateAlertSettingsForKitUser(kit.kitId,currentAlertUser.id,payload);
      
    });

    setMsg("Alert Settings Successfully updated");
    setSuccess(true);
    setopenToaster(true);
    setLoadingUsers(false);
    setShowAlertSettingsProject(false);
    setTimeout(function() {
        setopenToaster(false);
      }, 4000);
 
    }
    catch(error){
    setMsg("Error Updating  alert settings for project");
    setSuccess(false)
    setopenToaster(true);
    setLoadingUsers(false);
    setTimeout(function() {
        setopenToaster(false);
      }, 4000);
    return;
    }

  }

  // --- POPUPS ----------------------------------------------------------------

  const DeleteConfirmationPopup = ({ onClose, onConfirm, user }: any) => (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={modalHeaderStyle}>
          CONFIRMATION
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">
            ×
          </button>
        </div>
        <p style={modalTextStyle}>Are you sure you want to delete {user.name}?</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <button onClick={onClose} style={btnGhost}>
            Cancel
          </button>
          <button onClick={() => onConfirm(user)} style={btnDanger}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );

  const ResendConfirmationPopup = ({ onClose, onConfirm, user }: any) => (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={modalHeaderStyle}>
          CONFIRMATION
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">
            ×
          </button>
        </div>
        <p style={modalTextStyle}>Are you sure you want to resend registration mail?</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <button onClick={onClose} style={btnGhost}>
            NO
          </button>
          <button onClick={() => onConfirm(user)} style={btnPrimary}>
            YES
          </button>
        </div>
      </div>
    </div>
  );

  // --- HANDLERS --------------------------------------------------------------

  const currentList: Array<BaseUser | KitUser> =
    activeTab === "corporate"
      ? corporateUsers
      : activeTab === "project"
      ? projectUsers
      : kitUsers;

  const filteredList = currentList.filter((u: any) => {
    const t = searchTerm.toLowerCase();
    const matches =
      u.name.toLowerCase().includes(t) ||
      u.username.toLowerCase().includes(t) ||
      u.email.toLowerCase().includes(t) ||
      u.mobile.toLowerCase().includes(t) ||
      (u.whatsApp || "").toLowerCase().includes(t) ||
      (u.role || "").toLowerCase().includes(t);
    const filter =
      selectedFilter.startsWith("All")
        ? true
        : selectedFilter.startsWith("Active")
        ? u.status === "Active"
        : u.status === "Inactive";
    return matches && filter;
  });

  const handleCreateUser = async (userData: UserData, entityId: string, userRoleId?: number) => {
    try {
      const role = userRoleId !== undefined && userRoleId !== null
      ? userRoleId
      : Number(localStorage.getItem("ROLE"));

      const payload = {
        ...userData,
        userRoleId: role,
      };
      
      let response;
      
      if (activeTab === "corporate") {
        response = await createUserForCorporate(entityId, payload);
      } else if (activeTab === "project") {
        response = await createProjectUser(payload, entityId);
      } else if (activeTab === "kits") {
        response = await createUserForKit(selectedKitId, payload);
      }

      setShowCreateUserPopup(false);

      showToasterMessage("User created successfully!", true);

      if (activeTab === "corporate") {
        handleCorporateChange(selectedCorporateId);
      } else if (activeTab === "project") {
        handleProjectChange(selectedProjectId);
      } else if (activeTab === "kits") {
        handleKitChange(selectedKitId);
      }

    } catch (error) {
      console.error("Error creating user:", error);
      showErrorMessage(error, "Error creating user");
    }
  };

  const handleUpdateUser = async (updatedUserData: any) => {
    try {
      const payload = {
        ...updatedUserData,
        status: updatedUserData.status === "active" ? "ACTIVE" : "SUSPENDED",
      };

      let response;

    if (activeTab === "corporate") {
      response = await updateUserForCorporate(selectedCorporateId, editingUserId, payload);
    } else if (activeTab === "project") {
      response = await updateUser(selectedProjectId, editingUserId, payload);
    } else if (activeTab === "kits") {
      response = await updateUserForKit(selectedKitId, editingUserId, payload);
    }


      if (activeTab === "corporate") {
        handleCorporateChange(selectedCorporateId);
      } else if (activeTab === "project" && selectedProjectId) {
        handleProjectChange(selectedProjectId);
      } else if (activeTab === "kits" && selectedKitId) {
        handleKitChange(selectedKitId);
      }

      setShowEdit(false);
      setEditingUserId(null);
      showToasterMessage("User updated successfully!", true);
    } catch (error) {
      console.error("Error updating user:", error);
      let errMsg = "Please try again.";
      const errAny: any = error;
      if (errAny && errAny.response && errAny.response.data && errAny.response.data.message) {
        errMsg = errAny.response.data.message;
      } else if (errAny && errAny.message) {
        errMsg = errAny.message;
      }
      showToasterMessage(`Failed to update user: ${errMsg}`, false);
    }
  };

  const showErrorMessage = (error: any, defaultMsg: string) => {
    let msg = defaultMsg;
    if (error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    } else if (error && error.message) {
      msg = error.message;
    }
    showToasterMessage(msg, false);
  };

  const handleEditClick = (user: any) => {
    let entityId = "";
    let entityName = "";

    if (activeTab === "corporate") {
      entityId = selectedCorporateId;
      entityName = getCorporateName(selectedCorporateId);
    } else if (activeTab === "project") {
      entityId = selectedProjectId;
      entityName = getProjectName(selectedProjectId);
    } else if (activeTab === "kits") {
      entityId = selectedKitId;
      entityName = getKitName(selectedKitId);
    }

    setSelectedUser({
      entityId,
      entityName,
      email: user.email,
      name: user.name,
      mobile: user.mobile,
      whatsApp: user.whatsApp,
      status: user.status === "Active" ? "active" : "suspend",
    });

    setEditingUserId(user.id);
    setShowEdit(true);
  };

  const handleMailClick = (user: any) => {
    setSelectedUser(user);
    setShowResendConfirmation(true);
  };

  const handleDeleteClick = (user: any) => {
    setUserToDelete(user);
    setShowDeleteConfirmation(true);
  };



  const handleResendConfirm = (user: any) => {
    resendRegistrationMail({ email: user.email })
      .then(() => {
        showToasterMessage("Registration mail resent successfully.", true);
      })
      .catch((error) => {
        let errMsg = "Failed to resend registration mail.";
        if (error && error.response && error.response.data && error.response.data.message) {
          errMsg = error.response.data.message;
        } else if (error && error.message) {
          errMsg = error.message;
        }
        showToasterMessage(errMsg, false);
      })
      .finally(() => {
        setShowResendConfirmation(false);
      });
  };

  const handleCloseConfirmation = () => setShowResendConfirmation(false);

  const handleAssignUsers = (projectId: string, userIds: string[]) => {
    try{
     const response=addExistingUser(projectId,userIds)
     if(response.status=200){
      showToasterMessage("Users assigned successfully",true)
     }
     
    }
    catch(error){
      showErrorMessage("Error assigning users to project",error)
    }
  };
  const handleGoBackLog=()=>{
      setshowUserLog(false);
      setUserLog([]);
      setSelectedUser(null)
  }
  const handleOpenUserLog=(user)=>{
     setEditingUserId(user.id);
     setSelectedUser(user);
     getUserLog(user.id,pageSize,1);
     setshowUserLog(true);

  }
  const getUserLog = async (
    userId: string,
    offset: number,
    page: number,
    spinner = true
  ) => {
    if (spinner) setLoading(true);

    try {
      const response =
        await projectService.getUserActionHistory(userId, offset, page)
      setUserLog(response.data.content)
    } catch (err) {
      console.error(err);
    } finally {
      if (spinner) setLoading(false);

    }
  };

  // Keep the dropdown options consistent
  const topRightOptions = ["All", "Active", "Inactive"];

  // --- RENDER ----------------------------------------------------------------

  return (
    <div
       className="container-react"
      style={{
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: "#f9fafb",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
       <div className="page-title-container">
          <h2 className="page-title-react">  Users </h2>
        </div>
      {!showuserLog?
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 8,
          boxShadow: "0 1px 3px rgba(0,0,0,.1)",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Tabs */}
      
        <div style={{ borderBottom: "1px solid #e5e7eb", display: "flex", justifyContent: "space-around" }}>      
          {tabs.
          filter((tab) => hasMenuAccess(tab))
          .map((tab) => (     
            <button
              key={tab.id}
              onClick={() => {
                clearQueryParam();
                setActiveTab(tab.id);
                setSelectedFilter("All")
              }}
              style={{
                padding: isMobile ? "10px 12px" : "16px 24px",
                border: "none",
                background: "none",
                cursor: "pointer",
                fontSize: 16,
                fontWeight: 500,
                color: activeTab === tab.id ? "#2A7CED" : "#324054",
                borderBottom: activeTab === tab.id ? "2px solid #2A7CED" : "2px solid transparent",
                transition: "all .2s",
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Header Controls */}
        <div
          style={{
            padding: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
            borderBottom: "1px solid #e5e7eb",
            flexDirection:isMobile?"column":"row"
          }}
        >
          <div style={{ display: "flex", gap: 12, flex: 1,alignItems:"center",justifyContent:isMobile?"center":"flex-start",width:isMobile?"100%":"" }}>
            {/* Search */}
            <div style={{ position: "relative", maxWidth: 300, flex: 1, height: 40 }}>
              <span
                style={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.07670 3.07670C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.26640 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.26640 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z"
                    fill="#324054"
                  />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px 12px 10px 36px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box",
                  lineHeight: "20px",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#2A7CED")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#d1d5db")}
              />
            </div>

            {/* Filter (stub) */}
            <div style={{ position: "relative"}}>
              <button
                onClick={() => setShowFilterMenu(!showFilterMenu)}
                style={{
                  padding: "6px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6663 2H1.33301L6.66634 8.30667V12.6667L9.33301 14V8.30667L14.6663 2Z"
                    stroke="#324054"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {selectedFilter}
              </button>

              {showFilterMenu && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    background: "white",
                    border: "1px solid #d1d5db",
                    borderRadius: 4,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    zIndex: 100,
                  }}
                >
                  {["All", "Active", "Inactive"].map((filter) => (
                    <div
                      key={filter}
                      onClick={() => {
                        setSelectedFilter(filter);
                        setShowFilterMenu(false);
                      }}
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        backgroundColor: selectedFilter === filter ? "#f3f4f6" : "white",
                      }}
                    >
                      {filter}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", gap: 12, alignItems: "center",justifyContent:isMobile?"space-between":"flex-end",width:isMobile?"100%":"" }}>
            {/* Dropdown */}
            {activeTab === "corporate" && (
              <select
                value={selectedCorporateId}
                onChange={(e) => handleCorporateChange(e.target.value)}
                style={{
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer",
                  outline: "none",
                  width: isMobile?"70%":200,
                }}
              >
                <option value="">Select Corporate</option>
                {corporates.map((corp) => (
                  <option key={corp.id} value={corp.id}>
                    {corp.name}
                  </option>
                ))}
              </select>
            )}

            {activeTab === "project" && (
              <select
                value={selectedProjectId}
                onChange={(e) => handleProjectChange(e.target.value)}
                style={{
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer",
                  outline: "none",
                  width: isMobile?"calc(100% - 60px)":200,
                }}
              >
                <option value="">Select Project</option>
                {projects.map((proj) => (
                  <option key={proj.id} value={proj.id}>
                    {proj.name}
                  </option>
                ))}
              </select>
            )}

            {activeTab === "kits" && (
              <select
                value={selectedKitId}
                onChange={(e) => handleKitChange(e.target.value)}
                style={{
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer",
                  outline: "none",
                  minWidth: isMobile?"80%":200,
                  width:isMobile?"80%":""
                }}
              >
                <option value="">Select Kit</option>
                {kits.map((kit) => (
                  <option key={kit.id} value={kit.id}>
                    {kit.name}
                  </option>
                ))}
              </select>
              )}

            {activeTab === "project" &&authService.hasProjectManagementAccess()&& !authService.isCorporateSAASAdmin()&&(
              <button
                onClick={() => setShowAssignUsersPopup(true)}
                style={{
                  padding: isMobile?"5px":"6px 12px",
                  border: "1px solid #2A7CED",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  color: "#2A7CED",
                }}
              >
                {isMobile? <><AssignUserIcon color="#2A7CED"/></> :<><AddIcon/>  Assign Users</>}
              </button>
            )}

            {/* Add User Button (label changes per tab) */}
            {canCreateUser()?
            <button
              onClick={() => setShowCreateUserPopup(true)}
              style={{
                padding: isMobile?"5px":"6px 12px",
                backgroundColor: "#2A7CED",
                color: "white",
                border: "none",
                borderRadius: 4,
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                transition: "background-color .2s",
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = "#2A7CED")}
              onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = "#2A7CED")}
            >
              {isMobile?<AddUserIcon color="#ffffff"/>:    (<><AddIcon/>{activeTab === "kits" ? "Add Kit User" : activeTab === "project" ? "Add Project User" : "Add Corporate User"}</>)}
            </button>:<></>}
          </div>
        </div>

        {/* Table Container with Scroll */}
        <div style={{ overflowY: "auto", flex: 1, minHeight: "100px", maxHeight: "calc(100vh - 230px)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "#f9fafb" }}>
              <tr>
                {[
                    "Name",
                    ...(authService.isSuperAdmin() ? ["Username"] : []),
                    "Email",
                    "Phone No.",
                    "WhatsApp No.",
                    "Role",
                    "Status",
                    ...(activeTab === "kits" || activeTab === "project" ? ["Alert"] : []),
                    "Actions",
                ].map((header) => (
                  <th
                    key={header}
                    style={{
                      padding: "12px 16px",
                      textAlign: "left",
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#374151",
                      borderBottom: "1px solid #e5e7eb",
                      whiteSpace: "nowrap",
                      backgroundColor: "#f9fafb",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredList.length === 0 ? (
                <tr>
                  <td
                    colSpan={activeTab === "kits" || activeTab === "project" ? 9 : 8}
                    style={{
                      padding: "16px",
                      textAlign: "center",
                      color: "#6b7280",
                      fontWeight: 600,
                    }}
                  >
                    {activeTab === "corporate"
                      ? "No corporate users found."
                      : activeTab === "project"
                      ? "No project users found."
                      : "No kit users found."}
                  </td>
                </tr>
              ) : (
                filteredList.map((user: any, index: number) => (
                  <tr
                    key={index}
                    style={{ borderBottom: "1px solid #f3f4f6" }}
                    onMouseEnter={(e) => ((e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#f9fafb")}
                    onMouseLeave={(e) => ((e.currentTarget as HTMLTableRowElement).style.backgroundColor = "transparent")}
                  >
                    <td style={td}>{user.name}</td>
                    {authService.isSuperAdmin()&&<td style={td}>{user.username}</td>}
                    <td style={td}>{user.email}</td>
                    <td style={td}>{user.mobile}</td>
                    <td style={td}>{user.whatsApp}</td>
                    <td style={td}>{user.role}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <StatusBadge status={user.status} />
                    </td>

                    {(activeTab === "kits" ) && (
                      <>
                        <td style={tdCenter}>
                          <ActionButton
                            icon={<BellIconSmall/>}
                            altText="Edit Alert"
                            onClick={() => handleAlertSettingsClick(user, "sms")}
                          />
                        </td>
                      </>
                    )}
                     {(activeTab === "project") && (
                      <>
                        <td style={tdCenter}>
                          <ActionButton
                            icon={<BellIconSmall />}
                            altText="Edit Alert"
                            onClick={() => handleAlertSettingsProjectClick(user)}
                          />
                        </td>
                      </>
                    )}

                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                        {authService.hasProjectManagementAccess()&&<ActionButton iconSrc={editIcon} altText="Edit" onClick={() => handleEditClick(user)} />}
                        {authService.hasProjectUserManagementAccess()&&<ActionButton iconSrc={mailIcon} altText="Resend Registration Mail" onClick={() => handleMailClick(user)} />}
                         <ActionButton iconSrc={resetIcon} altText="user Log" onClick={() => handleOpenUserLog(user)} /> 
                         {authService.isSuperAdmin()&&<ActionButton iconSrc={deleteIcon} altText="Delete User" onClick={() => handleDeleteClick(user)} />}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>:
        <div  style={{
            padding:"10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height:"100%"
          }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",  
              gap: "12px",          
              padding: 0,
              height: "30px",
              paddingBottom:"20px"
            }}
          >
            <button
              onClick={() => handleGoBackLog()}
              style={{
                width: "24px",
                height: "24px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",     
                lineHeight: "24px",
                color: "#000000",

              }}
              aria-label="Back"
            >
              <ArrowBackIcon />
            </button>

            <h3
              style={{
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "20px",
                lineHeight: "30px",
                color: "#000000",
                margin: 0,
                whiteSpace: "nowrap",

              }}
            >
              User Log - {selectedUser.name}
            </h3>
          </div>


          {/* user log History */}
          <div style={{
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}>

            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 2fr 2fr",
              gap: "0",
              padding: "10px 18px",
              backgroundColor: "#E2E5ED",
              borderTop: "1px solid #E2E5ED",
              borderBottom: "1px solid #E2E5ED",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}>
              <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>ID</span>
              <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}> Action</span>
              <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Action at </span>
            </div>

            {displayed && displayed.length > 0 && displayed.map((row, index) => (
              <div
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 2fr 2fr",
                  gap: "0",
                  padding: "10px 18px",
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                  borderBottom: index < displayed.length - 1 ? "1px solid #E2E5ED" : "none"
                }}
              >
                <span style={{ fontSize: "14px", color: "#324054", fontWeight: 400, overflowX: "hidden", textOverflow: "ellipsis", padding: "5px" }}>{(currentPage-1)*pageSize+index+1}</span>
                <span style={{ fontSize: "14px", color: "#324054", fontWeight: 400, overflowX: "hidden", textOverflow: "ellipsis", padding: "5px" }}> {row.action}</span>
                <span style={{ fontSize: "14px", color: "#324054", fontWeight: 400, overflowX: "hidden", textOverflow: "ellipsis", padding: "5px" }}>{row.actionAt}</span>
              </div>
            ))}
            {userLog && userLog.length === 0 && (
              <div style={{ padding: "10px 18px", textAlign: "center", color: "#868DAA" }}>
                No user Log available
              </div>
            )}
                  <div  style={styleClasses.pagerWrapStyle}>
                    <button
                       style={{ ...styleClasses.pagerBtnStyle, ...(currentPage === 1 ? styleClasses.pagerBtnDisabled : {}) }}
                      disabled={currentPage === 1}
                      onClick={previousPage}
                    >
                      &laquo; {!isMobile?"Previous" : ""}
                    </button>
              <span
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 3,
                  padding: "0 3px",
                  // optional: subtle feedback while loading
                  animation: isLoading ? "pagerFade 0.6s ease-in-out infinite alternate" : undefined,
                }}
              >
                    {(() => {
                      const vp = visiblePages();
                      const parts: React.ReactNode[] = [];
            
                      if (vp.startPage > 1) {
                        parts.push(
                          <button
                            key={1}
                             style={{ ...styleClasses.pageNumberStyle, ...(currentPage === 1 ? styleClasses.pageNumberActive : {}) }}
                            onClick={() => goToPage(1)}
                          >
                            1
                          </button>
                        );
                        if (vp.startPage > 2) {
                          parts.push(
                            <span key="start-ellipsis"  style={styleClasses.pageEllipsisStyle}>
                              …
                            </span>
                          );
                        }
                      }
            
                      vp.pages.forEach((p) => {
                        parts.push(
                          <button
                            key={p}
                             style={{ ...styleClasses.pageNumberStyle, ...(currentPage === p ? styleClasses.pageNumberActive : {}) }}
                            onClick={() => goToPage(p)}
                          >
                            {p}
                          </button>
                        );
                      });
            
                      if (vp.endPage < effectiveTotalPages) {
                        if (vp.endPage < effectiveTotalPages - 1) {
                          parts.push(
                            <span key="end-ellipsis"  style={styleClasses.pageEllipsisStyle}>
                              …
                            </span>
                          );
                        }
                        parts.push(
                          <button
                            key={effectiveTotalPages}
                             style={{ ...styleClasses.pageNumberStyle, ...(currentPage === effectiveTotalPages ? styleClasses.pageNumberActive : {}) }}
                            onClick={() => goToPage(effectiveTotalPages)}
                          >
                            {effectiveTotalPages}
                          </button>
                        );
                      }
            
                      return parts;
                    })()}
                    </span>
            
                    <button
                       style={{ 
                        ...styleClasses.pagerBtnStyle,
                        ...((currentPage >= effectiveTotalPages && isAllRetrieved) ? styleClasses.pagerBtnDisabled : {}),
                      }}
                      disabled={currentPage >= effectiveTotalPages && isAllRetrieved}
                      onClick={nextPage}
                    >
                      {!isMobile?"Next" : ""} &raquo;
                    </button>
            
                    {!isMobile&&isLoading && (
                      <span  style={{ marginLeft: 8, color: "#666", fontSize: 13 }}>Loading…</span>
                    )}
                    {isAllRetrieved && effectiveTotalPages > 0 && (
                      <span  style={{ marginLeft: 8, color: "#888", fontSize: 13 }}>
                        All Data Retrieved
                      </span>
                    )}
                  </div>
          </div>
        </div>}
          <Loader isLoading={loadingUsers||loading} fullScreen={true} />

      {/* Create User Popup */}
      {showCreateUserPopup && (
        <CreateUser 
          onClose={() => setShowCreateUserPopup(false)} 
          onCreateUser={handleCreateUser} 
          projects={projects} 
          corporates={corporates}
          activeTab={activeTab}
        />
      )}

      {/* Edit User Popup */}
      {showEdit && <EditUser userData={selectedUser} onClose={() => setShowEdit(false)} onUpdateUser={handleUpdateUser} activeTab={activeTab} />}

      {/* Resend Confirmation Popup */}
      {showResendConfirmation && (
        <ResendConfirmationPopup onClose={() => setShowResendConfirmation(false)} onConfirm={handleResendMail} user={selectedUser} />
      )}

      {/* Delete Confirmation Popup */}
      {showDeleteConfirmation && userToDelete && (
        <DeleteConfirmationPopup
          onClose={() => setShowDeleteConfirmation(false)}
          onConfirm={handleDeleteUser}
          user={userToDelete}
        />
      )}

      {/* Assign Users Popup */}
      {showAssignUsersPopup && (
        <AssignUsersPopup
          onClose={() => setShowAssignUsersPopup(false)}
          onSave={handleAssignUsers}
          projects={projects}
        />
      )}

      {/* Alert Settings Popup */}
      {showAlertSettings && currentAlertUser && (
        <AlertSettingsPopup
          onClose={() => setShowAlertSettings(false)}
          onSave={handleSaveAlertSettings}
          initialSettings={currentAlertSettings}
          userName={currentAlertUser.name}
        />
      )}
            {/* Alert Settings Popup */}
      {showAlertSettingsProject && currentAlertUser && (
        <AlertSettingsProjectPopup
          onClose={() => setShowAlertSettingsProject(false)}
          onSave={handleProjectKitsAlertSettings}
          alertSettingProject={currentAlertSettingsProject}
          setAlertSettingsProject={setCurrentAlertSettingsProject}
          user={currentAlertUser}
        />
      )}

       <Toaster open={openToaster} isSuccess={success} msg={msg}/>
    </div>
  );
};

export default UserSetting;

/* ---------------------------- tiny style helpers --------------------------- */
const td: React.CSSProperties = { padding: "12px 16px", fontSize: 14, color: "#374151", whiteSpace: "nowrap" };
const tdCenter: React.CSSProperties = { ...td, textAlign: "left" };

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};
const modalStyle: React.CSSProperties = {
  borderRadius: 2,
  padding: 18,
  width: 700,
  boxShadow: "0 4px 12px rgba(0,0,0,.15)",
  backgroundColor: "white",
};
const modalHeaderStyle: React.CSSProperties = {
  margin: "0 0 16px 0",
  fontSize: 16,
  color: "##324054",
  textAlign: "left",
  backgroundColor: "white",
  display: "flex",
  justifyContent: "space-between",
  fontWeight: 500
};
const modalTextStyle: React.CSSProperties = { margin: "0 0 24px 0", fontSize: 14, color: "#6b7280", textAlign: "left", lineHeight: 1.5 };
const closeBtnStyle: React.CSSProperties = { background: "none", border: "none", cursor: "pointer", fontSize: 24, color: "#324054", fontWeight: "bold", lineHeight: 1 };

const btnGhost: React.CSSProperties = {
  padding: "8px 16px",
  backgroundColor: "#f3f4f6",
  color: "#324054",
  borderRadius: 4,
  fontSize: 14,
  cursor: "pointer",
  minWidth: 80,
  border: "1px solid #324054",
};
const btnDanger: React.CSSProperties = {
  padding: "8px 16px",
  backgroundColor: "#FF4343",
  color: "white",
  border: "none",
  borderRadius: 4,
  fontSize: 14,
  cursor: "pointer",
  minWidth: 80,
};
const btnPrimary: React.CSSProperties = {
  padding: "8px 16px",
  backgroundColor: "#2A7CED",
  color: "white",
  border: "none",
  borderRadius: 4,
  fontSize: 14,
  cursor: "pointer",
  minWidth: 80,
};

// Add these styles for the AssignUsersPopup component
const modalContentStyle: React.CSSProperties = {
  padding: "16px",
  maxHeight: "70vh",
  overflowY: "auto",
};
const kitSectionStyle: React.CSSProperties = {
    backgroundColor: "#F5F5F5",
    padding: "10px",
    borderRadius: "5px",
    marginBottom:"5px"
};

const formGroupStyle: React.CSSProperties = {
  marginBottom: "20px",
};

const labelStyle: React.CSSProperties = {
  display: "block",
  marginBottom: "12px",
  fontWeight: 500,
  color: "#374151",
  fontSize: "14px",
};

const selectStyle: React.CSSProperties = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #d1d5db",
  borderRadius: "4px",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
};

const usersListStyle: React.CSSProperties = {
  maxHeight: "200px",
  overflowY: "auto",
  border: "1px solid #d1d5db",
  borderRadius: "4px",
  padding: "8px",
};

const userItemStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  padding: "8px 0",
};

const checkboxStyle: React.CSSProperties = {
  marginRight: "8px",
};

const userLabelStyle: React.CSSProperties = {
  fontSize: "14px",
  color: "#324054",
  cursor: "pointer",
};

const modalFooterStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  padding: "16px",
};

// Add these styles for the AlertSettingsPopup component
const toggleGroupStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

const toggleItemStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  padding: '12px 0',
  borderBottom: '1px solid #f3f4f6'
};
const toggleItemGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  padding: '8px 12px',          
  width: '180px',              
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  border: '1px solid #e5e7eb',  
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
};
const toggleInfo: React.CSSProperties = {
  width:"100%",
  alignItems: 'center',
  padding: '5px 5px',                     
  fontSize:"11px",

};

const toggleLabelStyle: React.CSSProperties = {
  fontSize: '14px',
  color: '#324054',
  fontWeight: 500,
};

const subGroupStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  paddingLeft: '8px'
};

const subgrpRowStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',          
  paddingLeft: '4px',
  flexWrap: 'wrap'     
};

